const $header = document.querySelector('[data-role=header]') as HTMLElement;
const $menu = document.querySelector('[data-role=menu]') as HTMLElement;
const $footer = document.querySelector('[data-role=footer]') as HTMLElement;
const $bannerEl = document.querySelector('[data-role=banner]') as HTMLElement;
const $btns = document.querySelectorAll('[data-role=scroll-to]');
let isVisibleFooter = false;

$btns.forEach(($el) => {
	$el.addEventListener('click', (e) => {
		e.preventDefault();

		const href = $el.getAttribute('href');
		const $block = document.querySelector(`[data-role=${href}]`) as HTMLElement;

		$block.scrollIntoView({ behavior: 'smooth', block: 'start' });
	});
});

document.addEventListener('scroll', () => {
	const isWindowScrollFixed =  window.scrollY > 1;

	$header.classList.toggle('_scrolled', isWindowScrollFixed);
	$menu.classList.toggle('_sticky', isWindowScrollFixed && !isVisibleFooter);
});

const observerFooter = new IntersectionObserver( (entries) => {
	entries.forEach((entry) => {
		isVisibleFooter = entry.isIntersecting;

		$bannerEl.classList.toggle('_hidden', entry.isIntersecting);
	});
});

observerFooter.observe($footer);